import React from 'react';
import { Card, SpinnerIcon } from '@avila-tek/ui/src';
import { Title } from '../../../shared';
import { ChartInput } from '../../../../models';
import Doughnut from './Doughnut';
import Empty from '../Empty';

interface DoughnutChartProps extends ChartInput {
  loading: boolean;
  title: string;
}

function DoughnutChart({ data, labels, loading, title }: DoughnutChartProps) {
  const onlyZeros = data?.every((item) => item === 0);

  return (
    <Card className="w-full p-4 px-6 h-full flex   ">
      <Title title={title} />
      {!loading ? (
        <div className="flex flex-col items-center justify-center h-full">
          {data?.length > 0 && !onlyZeros ? (
            <Doughnut labels={labels} data={data} />
          ) : (
            <Empty />
          )}
        </div>
      ) : (
        <SpinnerIcon className="m-auto w-24 h-24 text-gray-200 animate-spin fill-purple-300" />
      )}
    </Card>
  );
}

export default DoughnutChart;
